import React from 'react';
import { translate } from '../../Services/translation';
import QuickSearchNavigation from './QuickSearchNavigation';

const NoResults = ({dataMenus}) => {
  return (
    <>
      <div className="[ quick-search-result__no-results ] [ text-xlarge color-grey-900 ]">
        {translate('quick-search-results.no-hits')}
      </div>
      <QuickSearchNavigation dataMenus={dataMenus}/>
    </>
  );
};

export default NoResults;
